export const validate_date = (date) => {
  return true;
  
};
